import React from 'react';

function UserManagement() {
    const users = [
        { username: 'sroot', role: 'admin' },
        { username: 'rbreuer', role: 'manager' },
        { username: 'yvonne', role: 'accounting' }
    ];

    return (
        <div>
            <h1>Benutzerverwaltung</h1>
            <table>
                <thead>
                    <tr>
                        <th>Benutzername</th>
                        <th>Rolle</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user) => (
                        <tr key={user.username}>
                            <td>{user.username}</td>
                            <td>{user.role}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default UserManagement;
